import React from 'react';
import { useFormContext } from 'react-hook-form';
import { Network } from 'screens/BrokerPortal/screens/Registration/api/types';
import { FIELD_NAMES } from '../../types';
import { CUSTOM_ERROR } from '../../validationSchema';
import { FormInputWrapper, Select } from 'form/infrastructure/reactHookForm';
import { Option } from 'form/components/Select/Select';
import { InputError } from 'form/components/InputWrapper/InputWrapper.styled';
import { Heading, Text } from 'lmc-ui-library-rebrand';

type Props = {
  title: string;
  name: string;
  networks: { loading: boolean; items: Network[] };
  loadNetworksByNetworkName: (networkName: string) => any;
};

export const NO_NETWORK_VALUE = 'NO_NETWORK_VALUE';

const cantFindNetworkOption: Option = {
  selectedRender: <span>I can't find my network</span>,
  label: "CAN'T FIND MY NETWORK",
  render: <b style={{ fontWeight: 700 }}>I CAN'T FIND MY NETWORK</b>,
  name: NO_NETWORK_VALUE,
  selected: false,
};

const FindNetwork: React.FC<Props> = ({ title, name, networks, loadNetworksByNetworkName }) => {
  const { setValue } = useFormContext();

  const reloadNetworkOptions = async (networkName: string) => {
    if (!networkName) {
      return;
    }
    loadNetworksByNetworkName(networkName);
  };

  const networkOptions = [
    ...networks.items.map((network: any) => ({
      label: network.name,
      name: network.id.toString(),
      selected: false,
    })),
    cantFindNetworkOption,
  ];

  return (
    <>
      <Heading mode="subheading" weight="bold">
        Choose your network
      </Heading>
      <Text color="var(--color-indigo-t11)">
        This should be the network that your firm is registered with on the FCA register. Commission fees will be paid
        to the network.
      </Text>

      <FormInputWrapper
        newUi
        name={name}
        title={title}
        customErrorMessages={[
          {
            type: CUSTOM_ERROR.NO_NETWORK,
            render: () => (
              <InputError>
                If you cannot find your network, then please contact us on <a href="tel:020 4525 7754">020 4525 7754</a>{' '}
                or email <a href="mailto: sales@livemoremortgages.com">sales@livemoremortgages.com</a> so that we can
                help with setting up your account
              </InputError>
            ),
          },
        ]}>
        <Select
          newUi
          options={networkOptions}
          isLoading={networks.loading}
          minSearchLengthToShowDroplist={1}
          onSearchInputChange={(value) => {
            reloadNetworkOptions(value);
          }}
          onNewUiOptionClick={(option) => {
            setValue(FIELD_NAMES.NETWORK, option.name, { shouldDirty: true, shouldValidate: true });
          }}
        />
      </FormInputWrapper>
    </>
  );
};

export default FindNetwork;
